import { DataHistory, DataModel } from '@shared/models/data-model';
import { MapFrom } from '@common/mapper/map-from.decorator';
import { PlatformAnnouncementDto } from '@data/_generated-api/platform-api/models/platform-announcement-dto';
import { NotificationLevel } from '@/app/platform/platform-data/models/notification-level';
import moment, { Moment } from 'moment';
import { Deletable, ModelFieldConfig } from '@/types/model.types';
import { Form } from '@common/formly/form.decorator';
import { ShowAnnouncementType } from '@/app/platform/platform-data/models/show-announcement-type';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { convertToMomentIfDefined } from '@common/utils/date-time-utils';
import { FormControl } from '@angular/forms';

const formConfig: ModelFieldConfig<Announcement>[] = [
  {
    key: 'show',
    type: 'enum-select',
    templateOptions: {
      label: 'Toon',
      required: true,
      translationKey: 'showAnnouncementType',
      enum: ShowAnnouncementType
    }
  },
  {
    key: 'showFrom',
    type: 'datetimepicker',
    templateOptions: {
      label: 'Van',
      required: true
    },
    expressions: {
      hide: (field: FormlyFieldConfig) => field.model.show !== ShowAnnouncementType.BetweenDates
    }
  },
  {
    key: 'showTo',
    type: 'datetimepicker',
    templateOptions: {
      label: 'Tot',
      required: true
    },
    expressions: {
      hide: (field: FormlyFieldConfig) => field.model.show !== ShowAnnouncementType.BetweenDates
    }
  },
  {
    key: 'level',
    type: 'enum-select',
    templateOptions: {
      label: 'Level',
      required: true,
      enum: NotificationLevel,
      translationKey: 'notificationLevel',
      omitValues: [NotificationLevel.Unknown]
    }
  },
  {
    key: 'key',
    type: 'input',
    templateOptions: {
      label: 'Key',
      required: true
    },
    validators: {
      custom: {
        message: 'Enkel de key "Platform is voorlopig toegelaten"',
        expression: (control: FormControl) => control.value === 'Platform'
      }
    }
  },
  {
    key: 'title',
    type: 'input',
    templateOptions: {
      label: 'Titel',
      required: true
    }
  },
  {
    key: 'message',
    type: 'textarea',
    templateOptions: {
      label: 'Boodschap',
      required: true
    }
  }
];

@Form('edit', formConfig)
@Form('create', formConfig)
@MapFrom<PlatformAnnouncementDto, Announcement>({
  createdOn: src => moment(src.createdOn),
  lastModifiedOn: src => moment(src.lastModifiedOn),
  showTo: src => convertToMomentIfDefined(src.showTo),
  showFrom: src => convertToMomentIfDefined(src.showFrom)
})
export class Announcement extends DataModel<string, Moment> implements Deletable {
  constructor(
    id: string,
    public key: string,
    public title: string,
    public message: string,
    public level: NotificationLevel,
    public show: ShowAnnouncementType,
    public showFrom: Moment | undefined,
    public showTo: Moment | undefined,
    public readonly lastModifiedByDisplayName: string,
    history?: DataHistory<Moment>
  ) {
    super(id, history);
  }

  get deleteKey() {
    return this.id;
  }

  static createDefault(): Announcement {
    return new Announcement(
      '',
      'Platform',
      '',
      '',
      undefined,
      ShowAnnouncementType.No,
      undefined,
      undefined,
      undefined
    );
  }
}
